import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import Layout from 'components/layout';
import Box from 'components/box';
import Head from 'components/head';

const Events = ({ data }) => (
  <Layout>
    <Head pageTitle={data.eventsJson.title} />
    <Box>
      <h2 style={{ fontSize: '2rem', marginBottom: '15px' }}>
        Resurrection Catholic Secondary School Presentation
      </h2>
      <Img
        fluid={
          data.eventsJson.image
            ? data.eventsJson.image.childImageSharp.fluid
            : {}
        }
        alt=""
      />
      <h2 style={{ fontSize: '2rem', marginBottom: '15px', marginTop: '30px' }}>
        Rosemary&apos;s Talk at 2017 Guelph Parenting Conference
      </h2>
      <iframe
        title="Conference video"
        width="560"
        height="315"
        src="https://www.youtube.com/embed/3ZLz8AWmMHo"
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullscreen
      />
    </Box>
  </Layout>
);

Events.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Events;

export const query = graphql`
  query EventsQuery {
    eventsJson {
      title
      content {
        childMarkdownRemark {
          html
        }
      }
      image {
        childImageSharp {
          fluid(maxWidth: 500, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
`;
